
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogi",
      function () {
        return require("private-next-pages/blogi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogi"])
      });
    }
  